<app-page-header headerImage="{{ headerImage }}"></app-page-header>
<div class="terms-conditions">
  <div class="terms-conditions_header">
    <h1 class="mat-display-small">Our terms &amp; conditions</h1>
  </div>
  <div class="core-content">
    @if (termsandconditions) {
      <div>
        <div [innerHTML]="termsandconditions"></div>
      </div>
    }
    @if (!termsandconditions) {
      <div class="app-loader">
        <div class="u-flex-center">
          <mat-spinner color="primary" diameter="50"></mat-spinner>
        </div>
      </div>
    }
  </div>
</div>
